export const MessagesAnswers = {
  Message: 'Správa',
  DateAnswer: 'Dátum odpovede',
  DatePreview: 'Dátum náhľadu',
  DateRead: 'Dátum prečítania',
  AnswerName: 'Odpoveď',
  AnswerValues: 'Hodnoty odpovede',
};
